import React from 'react';

function Footer() {
    return (
        <footer className="main-footer">
            <strong>Copyright &copy; 2024 <a href="https://pluss.co.in/" target='_blank'>PLUSS Advanced Technologies Ltd.</a> </strong>
            All rights reserved.
        </footer>
    );
}

export default Footer;
